/**
 * @prettier
 */
import { CardBrand, CardBrands } from 'src/constants/CardBrand';
import { upperCase } from 'src/utils/string/upperCase';

export function isKnownCard(cardBrand?: CardBrand): boolean {
    return [CardBrands.VISA, CardBrands.MASTERCARD, CardBrands.AMERICAN_EXPRESS, CardBrands.SODEXO].includes(upperCase(cardBrand) as CardBrand);
}
